import {
    initMain
} from './vue/controllers/main';

window.homeVue = initMain([], null, []);